<template>
	<div id="app" class="not-mobile">
		<div class="loader-wrapper" v-if="isLoading">
            <div class="loader"></div>
        </div>
		<app-header v-if="!useMobile"></app-header>
		<div class="app-container">
			<app-menu :menuData="menuData"></app-menu>
			<div class="main-container" id="main-container">
				<router-view :category="category" :meetingID="meetingID" :eventID="eventID" :menuData="menuData" :eventData="eventData" :results="results"></router-view>
			</div>
		</div>
	</div>
</template>

<script>
import Header from './components/layout/Header';
import Menu from './components/layout/Menu';
import { eventBus } from './main';

export default {
    name: 'app',
    data () {
    	return {
			isLoading: false,
			loadingMenu: false,
			loadingEvent: false,
			loadingMultiEvent: false,
			loadingResults: false,
			loadingNext: false,
			useMobile: false,
			category: this.$route.params.category,
			meetingID: this.$route.params.meetingID,
			eventID: this.$route.params.eventID,
			menuData: {
				'categories': {
					'vip-horse': {
						'name': 'VIP Horse Racing',
						'events': {}
					},
					'vip-greyhound': {
						'name': 'VIP Greyhounds',
						'events': {}
					},
					'vip-cycling': {
						'name': 'VIP Cycling',
						'events': {}
					},
					'vip-motor-racing': {
						'name': 'VIP Motor Racing',
						'events': {}
					},
					'vip-speedway': {
						'name': 'VIP Speedway',
						'events': {}
					}
				},
				'updated': 0
			},
			eventData: {
				'categories': {
					'vip-horse': {
						'name': 'VIP Horse Racing',
						'events': {}
					},
					'vip-greyhound': {
						'name': 'VIP Greyhounds',
						'events': {}
					},
					'vip-cycling': {
						'name': 'VIP Cycling',
						'events': {}
					},
					'vip-motor-racing': {
						'name': 'VIP Motor Racing',
						'events': {}
					},
					'vip-speedway': {
						'name': 'VIP Speedway',
						'events': {}
					}
				}
			},
			results: {
				'vip-horse-racing': [
					{
						'name': 'Ayr 14:00',
						'details': '3m 70y Hcap Hurdle',
						'startTime': '2nd Jan 19 14:00',
						'eachWay': 'Each way 1/5 odds 1-2-3',
						'selections': [
							{
								'number': 6,
								'position': 3,
								'name': 'Sebastopol',
								'details': 'A Coleman',
								'price': '555/1'
							},
							{
								'number': 1,
								'position': 2,
								'name': 'Dali Mail',
								'details': 'C Whillans',
								'price': '10/3'
							},
							{
								'number': 9,
								'position': 5,
								'name': 'Whoshotthesheriff',
								'details': 'S Quinlan',
								'price': '5/1'
							},
							{
								'number': 5,
								'position': 1,
								'name': 'Not The Chablis',
								'details': 'L Alexander',
								'price': '16/1'
							},
							{
								'number': 8,
								'position': 4,
								'name': 'Timesawaiting',
								'details': 'S Mulqueen',
								'price': '25/1'
							}
						]
					},
					{
						'name': 'Ayr 15:00',
						'details': '3m 70y Hcap Hurdle',
						'startTime': '2nd Jan 19 15:00',
						'eachWay': 'Each way 1/5 odds 1-2-3',
						'selections': [
							{
								'number': 6,
								'position': 3,
								'name': 'Sebastopol',
								'details': 'A Coleman',
								'price': '4/7'
							},
							{
								'number': 1,
								'position': 2,
								'name': 'Dali Mail',
								'details': 'C Whillans',
								'price': '10/3'
							},
							{
								'number': 9,
								'position': 5,
								'name': 'Whoshotthesheriff',
								'details': 'S Quinlan',
								'price': '5/1'
							},
							{
								'number': 5,
								'position': 1,
								'name': 'Not The Chablis',
								'details': 'L Alexander',
								'price': '16/1'
							},
							{
								'number': 8,
								'position': 4,
								'name': 'Timesawaiting',
								'details': 'S Mulqueen',
								'price': '25/1'
							}
						]
					},
					{
						'name': 'Ayr 16:00',
						'details': '3m 70y Hcap Hurdle',
						'startTime': '2nd Jan 19 16:00',
						'eachWay': 'Each way 1/5 odds 1-2-3',
						'selections': [
							{
								'number': 6,
								'position': 3,
								'name': 'Sebastopol',
								'details': 'A Coleman',
								'price': '4/7'
							},
							{
								'number': 1,
								'position': 2,
								'name': 'Dali Mail',
								'details': 'C Whillans',
								'price': '10/3'
							},
							{
								'number': 9,
								'position': 5,
								'name': 'Whoshotthesheriff',
								'details': 'S Quinlan',
								'price': '5/1'
							},
							{
								'number': 5,
								'position': 1,
								'name': 'Not The Chablis',
								'details': 'L Alexander',
								'price': '16/1'
							},
							{
								'number': 8,
								'position': 4,
								'name': 'Timesawaiting',
								'details': 'S Mulqueen',
								'price': '25/1'
							}
						]
					},
					{
						'name': 'Ayr 17:00',
						'details': '3m 70y Hcap Hurdle',
						'startTime': '2nd Jan 19 17:00',
						'eachWay': 'Each way 1/5 odds 1-2-3',
						'selections': [
							{
								'number': 6,
								'position': 3,
								'name': 'Sebastopol',
								'details': 'A Coleman',
								'price': '4/7'
							},
							{
								'number': 1,
								'position': 2,
								'name': 'Dali Mail',
								'details': 'C Whillans',
								'price': '10/3'
							},
							{
								'number': 9,
								'position': 5,
								'name': 'Whoshotthesheriff',
								'details': 'S Quinlan',
								'price': '5/1'
							},
							{
								'number': 5,
								'position': 1,
								'name': 'Not The Chablis',
								'details': 'L Alexander',
								'price': '16/1'
							},
							{
								'number': 8,
								'position': 4,
								'name': 'Timesawaiting',
								'details': 'S Mulqueen',
								'price': '25/1'
							}
						]
					}
				],
				'vip-greyhounds': [
					{
						'name': 'Belle Vue Stadium 14:00',
						'details': '470',
						'startTime': '2nd Jan 19 14:00',
						'eachWay': 'Each way 1/4 odds 1-2',
						'selections': [
							{
								'number': 1,
								'position': 1,
								'name': 'Impressive Lad',
								'details': '',
								'price': '5/1'
							},
							{
								'number': 2,
								'position': 4,
								'name': 'Ballymac Alfred',
								'details': '',
								'price': '13/2'
							},
							{
								'number': 3,
								'position': 3,
								'name': 'Ballymac Sylvia',
								'details': '',
								'price': '7/4'
							},
							{
								'number': 4,
								'position': 2,
								'name': 'Dumgower Hope',
								'details': '',
								'price': '6/5'
							}
						]
					},
					{
						'name': 'Belle Vue Stadium 15:00',
						'details': '470',
						'startTime': '2nd Jan 19 15:00',
						'eachWay': 'Each way 1/4 odds 1-2',
						'selections': [
							{
								'number': 1,
								'position': 1,
								'name': 'Impressive Lad',
								'details': '',
								'price': '5/1'
							},
							{
								'number': 2,
								'position': 4,
								'name': 'Ballymac Alfred',
								'details': '',
								'price': '13/2'
							},
							{
								'number': 3,
								'position': 3,
								'name': 'Ballymac Sylvia',
								'details': '',
								'price': '7/4'
							},
							{
								'number': 4,
								'position': 2,
								'name': 'Dumgower Hope',
								'details': '',
								'price': '6/5'
							}
						]
					},
					{
						'name': 'Belle Vue Stadium 16:00',
						'details': '470',
						'startTime': '2nd Jan 19 16:00',
						'eachWay': 'Each way 1/4 odds 1-2',
						'selections': [
							{
								'number': 1,
								'position': 1,
								'name': 'Impressive Lad',
								'details': '',
								'price': '5/1'
							},
							{
								'number': 2,
								'position': 4,
								'name': 'Ballymac Alfred',
								'details': '',
								'price': '13/2'
							},
							{
								'number': 3,
								'position': 3,
								'name': 'Ballymac Sylvia',
								'details': '',
								'price': '7/4'
							},
							{
								'number': 4,
								'position': 2,
								'name': 'Dumgower Hope',
								'details': '',
								'price': '6/5'
							}
						]
					},
					{
						'name': 'Belle Vue Stadium 17:00',
						'details': '470',
						'startTime': '2nd Jan 19 17:00',
						'eachWay': 'Each way 1/4 odds 1-2',
						'selections': [
							{
								'number': 1,
								'position': 1,
								'name': 'Impressive Lad',
								'details': '',
								'price': '5/1'
							},
							{
								'number': 2,
								'position': 4,
								'name': 'Ballymac Alfred',
								'details': '',
								'price': '13/2'
							},
							{
								'number': 3,
								'position': 3,
								'name': 'Ballymac Sylvia',
								'details': '',
								'price': '7/4'
							},
							{
								'number': 4,
								'position': 2,
								'name': 'Dumgower Hope',
								'details': '',
								'price': '6/5'
							}
						]
					}
				],
				'vip-cycling': [
					{
						'name': 'Tour de France 2019',
						'details': '',
						'startTime': '28th Jul 19 12:00',
						'eachWay': 'Each Way: 1/4 odds - places 1,2,3',
						'selections': [
							{
								'number': 1,
								'position': 1,
								'name': 'Chris Froome',
								'details': '',
								'price': '6/4'
							},
							{
								'number': 2,
								'position': 4,
								'name': 'Geraint Thomas',
								'details': '',
								'price': '15/8'
							},
							{
								'number': 3,
								'position': 2,
								'name': 'Tom Dumoulin',
								'details': '',
								'price': '4/1'
							},
							{
								'number': 4,
								'position': 3,
								'name': 'Richie Porte',
								'details': '',
								'price': '8/1'
							}
						]
					}
				],
				'vip-motor-racing': [
					{
						'name': '2018/2019 Formula E Championship',
						'details': '',
						'startTime': '14th Jul 19 20:03',
						'eachWay': 'Each Way: 1/5 odds - places 1,2,3',
						'selections': [
							{
								'number': 1,
								'position': 1,
								'name': 'Jean-Eric Vergne',
								'details': '',
								'price': '13/8'
							},
							{
								'number': 2,
								'position': 3,
								'name': 'Antonio Felix Da Costa',
								'details': '',
								'price': '10/3'
							},
							{
								'number': 3,
								'position': 2,
								'name': 'Andre Lotterer',
								'details': '',
								'price': '9/2'
							},
							{
								'number': 4,
								'position': 4,
								'name': 'Lucas Di Grassi',
								'details': '',
								'price': '15/2'
							}
						]
					}
				],
				'vip-speedway': [
					{
						'name': 'SGB Premiership',
						'details': '',
						'startTime': '',
						'eachWay': '',
						'selections': [
							{
								'number': 1,
								'position': 2,
								'name': 'Belle Vue Aces',
								'details': '',
								'price': '14/3'
							},
							{
								'number': 2,
								'position': 3,
								'name': 'Ipswich Witches',
								'details': '',
								'price': '16/3'
							},
							{
								'number': 3,
								'position': 4,
								'name': 'King\'s Lynn Stars',
								'details': '',
								'price': '7/4'
							},
							{
								'number': 4,
								'position': 1,
								'name': 'Peterborough Panthers',
								'details': '',
								'price': '12/7'
							}
						]
					}
				]
			}
    	}
	},
	components: {
		'appMenu': Menu,
		'appHeader': Header
	},
	watch: {
		'$route' (to, from) {
			eventBus.$emit('clearEvent');

			this.category = to.params.category;
			this.meetingID = to.params.meetingID;
			this.eventID = to.params.eventID;
			
			eventBus.$emit('loadMenu');

			let main = document.getElementById('main-container');
			main.scrollTop = 0;
        }
	},
	created() {
		var _self = this;
		this.category = this.$route.params.category;
		this.meetingID = this.$route.params.meetingID;
		this.eventID = this.$route.params.eventID;

		setInterval(() => {
			this.deleteOldEvents();
		}, 30000);

		eventBus.$on('loading', (loading) => {
			switch(loading[0]) {
				case 'Menu':
					_self.loadingMenu = loading[1];
					break;
				case 'Event':
					_self.loadingEvent = loading[1];
					break;
				case 'MultiEvent':
					_self.loadingMultiEvent = loading[1];
					break;
				case 'Results':
					_self.loadingResults = loading[1];
				case 'Next':
					_self.loadingNext = loading[1];
			}

			if(
				_self.loadingMenu == true       ||
				_self.loadingEvent == true      ||
				_self.loadingMultiEvent == true ||
				_self.loadingResults == true    ||
				_self.loadingNext == true
			) {
				_self.isLoading = true;
			} else {
				_self.isLoading = false;
			}

			eventBus.$emit('appLoading', _self.isLoading);
		});

		eventBus.$on('isMobile', (isMobile) => {
			var app = document.getElementById('app');

			if(app.classList.contains('not-mobile') && isMobile) {
				app.classList.remove('not-mobile');
			} else if(!isMobile) {
				app.classList.add('not-mobile');
			}

			_self.useMobile = isMobile;
		});

		eventBus.$on('menuLoaded', (menu) => {
			_self.menuData = menu[1];
			this.$forceUpdate();
		});

		eventBus.$on('eventLoaded', () => {
			this.forceUpdate(this.eventData);
		});
		
		eventBus.$on('updateEventUpdated', (events) => {
			if(events.length > 0) {
				events.forEach((event) => {
					if(typeof this.menuData.categories[event.category].events[event.meetingID] == 'undefined') return;
					this.menuData.categories[event.category].events[event.meetingID].events.forEach((ev, index) => {
						if(ev.ID == event.ID) {
							this.menuData.categories[event.category].events[event.meetingID].events[index].updated = event.updated;
						}
					});
				});
			}
		});

		eventBus.$on('updateEvent', (event) => {
			
			this.eventData.categories[event.category].events[event.event.meetingID].events.forEach((ev, index) => {
				if(ev.ID == event.event.ID) {
					for(let k in event.event) {
						this.eventData.categories[event.category].events[event.event.meetingID].events[index][k] = event.event[k];
					}
				}
			});
			this.forceUpdate(this.eventData);
		});

		eventBus.$on('addEvent', (event) => {
			if(!(this.eventData.categories[event.category].events[event.event.meetingID])) this.eventData.categories[event.category].events[event.event.meetingID] = {
				'name': event.event.meetingName,
				'events': []
			};
			this.eventData.categories[event.category].events[event.event.meetingID].events.push(event.event);
			this.forceUpdate(this.eventData);
		});

		eventBus.$on('deleteEvent', (data) => {
			let category = data['category'];
			let meeting = data['meetingID'];
			let eventID = data['eventID'];
			this.eventData.categories[category].events[meeting].events.forEach((event, index) => {
				if(event.ID == eventID) {
					this.eventData.categories[category].events[meeting].events.splice(index, 1);
				}
			});
		});
	},
	methods: {
		forceUpdate(data) {
			let tmp = this.sortEvents(data);
			eventBus.$emit('eventsLoading', tmp);
		},
		updateMenu(data) {
			let tmp = this.sortEvents(data);
			eventBus.$emit('menuLoading', tmp);
		},
		sortEvents(data) {
			var tmp = data;

			for(var c in tmp.categories) {
				var category = tmp.categories[c];

				if(!category || !category.events) continue;

				for(var m in category.events) {
					var meeting = category.events[m];

					if(!meeting || !meeting.events) continue;

					tmp.categories[c].events[m].events.sort(this.compareEvents);
				}
			}

			return tmp;
		},
		compareEvents(a, b) {
			if(a.name < b.name) return -1;
			if(a.name > b.name) return 1;
			return 0;
		},
		deleteOldEvents() {
			this.$API.GetCurrentServerTime((response) => {
				let res = response.result;

				if(response.status == 0) {
                    console.error(res.errors);
                    return;
				}

				let date = new Date(res * 1000);

				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				if(month < 10) month = '0' + month;
				let day = date.getDate();
				if(day < 10) day = '0' + day;
				let hour = date.getHours();
				let minute = date.getMinutes();
				if(minute < 10) minute = '0' + minute;
				let second = date.getSeconds();
				if(second < 10) second = '0' + second;

				var time = day + '/' + month + '/' + year + ' ' + hour + ':' + minute + ':' + second;

				for(let c in this.menuData.categories) {
					let category = this.menuData.categories[c];

					for(let m in category.events) {
						let meeting = category.events[m];

						meeting.events.forEach((event, index) => {
							if(event.startTime < time) {
								this.menuData.categories[c].events[m].events.splice(index, 1);
							}
						});
					}
				}

				this.updateMenu(this.menuData);

				for(let c in this.eventData.categories) {
					let category = this.eventData.categories[c];

					for(let m in category.events) {
						let meeting = category.events[m];

						meeting.events.forEach((event, index) => {
							if(event.startTime < time) {
								this.eventData.categories[c].events[m].events.splice(index, 1);
							}
						});
					}
				}

				this.forceUpdate(this.eventData);
			});
		}
	}
}
</script>

<style lang="less">
@import './assets/css/fontawesome.min.css';
@import './assets/css/solid.min.css';

html,
body,
#app {
	width: 100%;
	height: 100%;
}

body {
	padding-top: 50px;
	font-family: 'Open Sans', sans-serif;
}

#app {
	width: 100%;
	height: 100%;
}

.main-container {
	background-color: #d3d3d3;
	overflow-y: auto;
	height: 100%;
}

#app.not-mobile .app-container {
	display: flex;
	flex-direction: row;
	margin-left: 300px;

	.main-container {
		flex-grow: 1;
		padding: 10px;
	}
}
#app .app-container {
	height: 100%;
}

.loader-wrapper {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    opacity: 0.25;
    z-index: 1000;

    .loader {
        border: 10px solid #f3f3f3;
        border-top: 10px solid darken(#f3f3f3, 50%);
        border-radius: 50%;
        width: 75px;
        height: 75px;
        animation: spin 2s linear infinite;
    }
}
@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

@media (max-width: 420px) {
	body {
		font-size: 14px;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue